/**
 * Construit un objet profil Twitch minimal à partir des champs résumé du JWT (/auth/verify),
 * lorsque twitch.userData n'est pas encore disponible.
 * @param {Object|null} sessionUser - Utilisateur session
 * @returns {Object|null}
 */
export function buildTwitchUserFromSessionSummary(sessionUser) {
  if (!sessionUser) return null;
  const hasSummary =
    sessionUser.twitchId ||
    sessionUser.twitchLogin ||
    sessionUser.twitchDisplayName;
  if (!hasSummary) return null;
  return {
    id: sessionUser.twitchId || sessionUser.id,
    login: sessionUser.twitchLogin || '',
    display_name:
      sessionUser.twitchDisplayName ||
      sessionUser.twitchLogin ||
      'Twitch',
    profile_image_url: sessionUser.profileImageUrl || '',
    description: '',
    created_at: null,
  };
}

/**
 * Résout l'utilisateur Twitch à afficher sur la page profil (session JWT, résumé, puis localStorage).
 * @param {Object} params
 * @param {() => Object|null} params.getTwitchUser - twitch.userData depuis la session
 * @param {Object|null} params.sessionUser - Objet user /auth/verify
 * @param {(key: string) => unknown} params.storageGet - Lecture localStorage (ex. storage.get)
 * @param {string} params.storageKey - Clé du legacy twitchUser
 * @returns {Object|null}
 */
export function resolveProfileTwitchUser({
  getTwitchUser,
  sessionUser,
  storageGet,
  storageKey,
}) {
  let twitchUser = getTwitchUser();
  if (!twitchUser) {
    twitchUser = buildTwitchUserFromSessionSummary(sessionUser);
  }
  if (!twitchUser) {
    const storedUser = storageGet(storageKey);
    twitchUser = storedUser || null;
  }
  return twitchUser;
}
